/**
 * @file
 * Patria hero Vimeo video controls and scroll down.
 * Used on front page and modular page.
 */

(function ($, Drupal) {

  'use strict';

  Drupal.behaviors.patriaHeroScrollDown = {
    attach: () => {
      $('.hero-scroll-down').on('click', function () {
        var element = $('.region-content-top');
        var elementOffset = element.offset();
        var offsetPosition = elementOffset.top - 100;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      });
    },
  };

  // Handle Vimeo video controls
  Drupal.behaviors.patriaHeroVideoControls = {
    attach: () => {
      var iframe = document.querySelector('.media-wrapper iframe');

      if (iframe) {
        var player = new Vimeo.Player(iframe);

        $('.media-wrapper .video-controls__resume').on('click', function () {
          player.play();
          $('.media-wrapper .video-controls__pause').show();
          $(this).hide();
        });

        $('.media-wrapper .video-controls__pause').on('click', function () {
          player.pause();
          $('.media-wrapper .video-controls__resume').show();
          $(this).hide();
        });
      }
    }
  };

})(jQuery, Drupal);
